import { isAccountBalancePaymentPaid } from '../../../functions/sale'
import type { Sale } from '../../../models/sale'
/**
 * Returns true when confirmation is for an ABP-only flow.
 *
 * Note: we still receive a `Sale` model here because confirmation selectors
 * always hydrate that shape, even for sale-less ABP flows.
 *
 * ABP-only means the account balance payment is paid and there are no sale
 * products (including unknown line items) attached to the confirmation state.
 */
export const isAbpOnlyConfirmationFlow = (sale: Sale): boolean => {
  return (
    Boolean(sale.payAccountBalance?.abpTransactionId) &&
    isAccountBalancePaymentPaid(sale.payAccountBalance) &&
    sale.lineItems.length === 0 &&
    sale.unknownLineItems.length === 0
  )
}
